import { FC, memo } from "react";
import { ColumnProps } from "./Column.types";
import BoxItem from "../../../assets/box.png";
import Bomb from "../../../assets/bomb.png";
import { gunImages, rotates } from "../../../config/zone.config";
import { PLAYER_HEALTH } from "../../../config";

const Column: FC<ColumnProps> = ({
  hasBomb,
  hasBoxes,
  isDanger,
  gunClassName,
  playerHealth,
  posX,
  posY,
  index,
  gun,
  lastMove,
  i,
  findFreezed,
  enemiesCount,
  enemiesHealth,
}) => {
  return (
    <div
      className={`${isDanger ? "dangercol" : "col"} ${gunClassName} small`}
      style={{
        backgroundImage: hasBoxes ? `url(${hasBomb ? Bomb : BoxItem})` : "",
        backgroundSize: 18,
      }}
    >
      {index === posX && i === posY && (
        <div className="player">
          <div className="health">
            <div
              className="remain"
              style={{ width: (playerHealth / PLAYER_HEALTH) * 100 + "%" }}
            ></div>
          </div>
          <img
            src={gunImages[gun]}
            style={{
              transform: `rotate(${rotates[lastMove]}deg)`,
              width: "20px",
              height: "20px",
            }}
            alt=""
          />
        </div>
      )}
      {!!enemiesCount && (
        <div
          className={`${enemiesCount >= 100 ? "enemyBig" : "enemy"}${
            findFreezed ? " freezed" : ""
          }`}
        >
          <div className="enemyHealth">{enemiesHealth}</div>
          {enemiesCount}
        </div>
      )}
    </div>
  );
};

export default memo(Column);
